export default __webpack_public_path__ + "static/20241019-postdev-fe169f01e886139b8e225e2fbf1d6e80.png";